import { render, staticRenderFns } from "./IconBtn.vue?vue&type=template&id=2ebe693b&scoped=true"
import script from "./IconBtn.vue?vue&type=script&lang=ts"
export * from "./IconBtn.vue?vue&type=script&lang=ts"
import style0 from "./IconBtn.vue?vue&type=style&index=0&id=2ebe693b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebe693b",
  null
  
)

export default component.exports